import { useLazyQuery } from "@apollo/client";
import { gql } from "generated-graphql";
import type {
  SubmissionDocumentInputForValidation,
  SubmissionInputForValidation,
} from "generated-graphql/graphql";
import { omit } from "lodash";
import { useCallback } from "react";
import { useParams } from "react-router-dom";

const VALIDATE_SUBMISSION_INPUT = gql(`
  query ValidateSubmissionInput($input: SubmissionInputForValidation!) {
    submissionInputValidator(input: $input) {
      ...issue
    }
  }
`);

export function useSubmissionInputValidation(
  documents: SubmissionDocumentInputForValidation[]
) {
  const [query] = useLazyQuery(VALIDATE_SUBMISSION_INPUT as any, {
    fetchPolicy: "no-cache",
  });

  const { tenantId = "" } = useParams();

  return useCallback(
    async (input: SubmissionInputForValidation) => {
      const { data } = await query({
        variables: {
          input: {
            ...{
              ...input,
              comments: input.comments?.map((c) =>
                omit(c, "user", "userId", "createdAt")
              ),
            },
            tenantId,
            documents,
          },
        },
      });

      return data?.submissionInputValidator ?? [];
    },
    [query, tenantId, documents]
  );
}
